<div>
  <mat-spinner style="margin: 0 auto"></mat-spinner>
  <br />
  <h3 style="text-align: center">Sending</h3>
  <br />
  <p style="text-align: center">Uploading may take some time</p>
</div>
